<template>

  <div class="p-3">

    <div class="d-flex flex-wrap mb-3">
      <div 
        v-if="permissions.includes('manage_jobs')"
        class="m-1">
        <button 
          class="btn btn-secondary" 
          @click="redefinedApprovalflow()">
          {{ $t('Reset') }}
          </button>
      </div>
    </div>

    <div :class="{'box-loading': loading}"></div>
    <div v-if="message" class="alert alert-warning">{{ message }}</div>

    <Approvalflow
      :approvalflowId="approvalflowId"
      @derefine="redefinedApprovalflow"
      @deleted=""
      @started="" />

  </div>

</template>

<script>
import Approvalflow from '@/components/Approvalflow/Approvalflow'

export default {
  name: 'JobApprovalflow',
  components: {
    Approvalflow
  },
  data () {
    return {
      loading: false,
      message: ''
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    job () {
      return this.$store.getters.getJob
    },
    approvalflowId () {
      return this.job.approvalflow ? this.job.approvalflow._id : null
    }
  },
  created () {
  },
  methods: {
    redefinedApprovalflow () {
      this.loading = true

      this.$store
      .dispatch('redefinedJobApprovalflow', this.job._id)
      .then((result) => {
        this.loading = false
        this.message = null
      })
      .catch((error) => {
        this.loading = false
        if (error.response.data) {
          this.message = error.response.data.message
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobApprovalflow/JobApprovalflow.vue